module.exports = __webpack_public_path__ + "static/heroBg3-45a8fe0cd3956505d6e0661d83fcad6b.jpg";